import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { CdkAccordion, CdkAccordionItem } from "@angular/cdk/accordion";
import { BigButtonComponent } from "../../../../shared/components/big-button/big-button.component";
import { ChipsComponent } from "../../../../shared/modules/chips/chips.component";
import { DashboardFacadeService } from "../../services/dashboard-facade.service";
import { Widget, WidgetType } from "../../models/dashboard.model";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslatePipe } from "../../../../shared/pipes/translate.pipe";

@Component({
  selector: "vl-dashboard-settings-panel",
  standalone: true,
  imports: [
    MatIcon,
    CdkAccordion,
    CdkAccordionItem,
    BigButtonComponent,
    ChipsComponent,
    TranslatePipe,
  ],
  templateUrl: "./dashboard-settings-panel.component.html",
  styleUrl: "./dashboard-settings-panel.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSettingsPanelComponent {
  data = inject(MAT_DIALOG_DATA);

  dashboardFacade = inject(DashboardFacadeService);
  dialogRef = inject(MatDialogRef);

  addWidget(type: WidgetType) {
    this.dashboardFacade.addWidget({ type } as Widget);
  }

  removeWidget(type: WidgetType) {
    const widget = this.dashboardFacade
      .displayWidgets()
      .find((w) => w.type === type);
    if (widget) {
      this.dashboardFacade.removeWidget(widget);
    }
  }

  async showPersoDashboard() {
    this.dashboardFacade.patchState({ globalDashboard: false });
    await this.dashboardFacade.loadDashboard(this.data.type);
  }

  async showGlobalDashboard() {
    this.dashboardFacade.patchState({ globalDashboard: true });
    await this.dashboardFacade.loadDashboard(this.data.type);
  }

  async resetDashboard() {
    await this.dashboardFacade.resetDashboard();
    await this.showGlobalDashboard();
  }
}
